module.exports = __webpack_public_path__ + "img/8e0a6b66454a44fb8d28362ed2598234.112a14d5.png";